import React from 'react';
import {
  Input, Card, Table, Button, Breadcrumb,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import MainLayout from '@common/layouts/MainLayout';

import useDeviceTypes from './useDeviceTypes';
import styles from './DeviceTypes.module.less';

function DeviceTypes() {

  const { t } = useTranslation();
  const {
    loading,
    pagination,
    columns,
    devicesType,
    arrayFilter,
    setValueFilter, 
    handleTableChange,
    createDeviceType,
    isCreate
  } = useDeviceTypes();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.device_types')}</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.rowHeader}>
          <Input
            placeholder={t('common.find_device_type')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)} 
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />

          {
            isCreate && 
            <div className={styles.button}>
              {`• ${devicesType.length} ${t('views.create_device_types.conectedDevicetypes')}`}
              <Button type="primary" onClick={createDeviceType} icon={<PlusOutlined />}>
                {t('views.create_device_types.new_device_type')}
              </Button>
            </div>
          }
         
        </div>

        <Card>
          <Table
            // scroll={{ x: 1210 }}
            className={styles.table}
            loading={loading}
            columns={columns}
            dataSource={arrayFilter}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey={(record) => record.id}
          />
        </Card>
      </div>
    </MainLayout>
  );

}

export default withAuth(DeviceTypes);
